import React, { useState, useEffect } from 'react';
import '../assets/stylesheets/privacy.css';
import axios from 'axios';

function PrivacyPolicy() {
  const [loading, setLoading] = useState(true);
  const [policyData, setPolicyData] = useState(null);
  const server_url = process.env.REACT_APP_API_URI;

  const fetchPolicy = async () => {
    try {
      const response = await axios.get(`${server_url}/admin/legal/privacy`);
      const list = Array.isArray(response.data?.data) ? response.data.data : [];
      const sorted = [...list].sort((a, b) => {
        const aDate = new Date(
          a?.updatedAt || a?.effectiveAt || a?.createdAt || 0,
        ).getTime();
        const bDate = new Date(
          b?.updatedAt || b?.effectiveAt || b?.createdAt || 0,
        ).getTime();
        return bDate - aDate;
      });
      setPolicyData(sorted[0] || null);
    } catch (error) {
      console.error('Error fetching privacy policy:', error);
      setPolicyData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPolicy();
  }, []);

  return (
    <>
      <div className="min-h-[calc(100vh-300px)] max-w-screen-xl mx-auto mt-6 mb-4">
        <h1 className="text-4xl font-bold text-white text-center mb-6">
          {policyData?.title || 'Privacy Policy'}
        </h1>
        <p className="text-center text-gray-400 text-sm mb-4">
          Effective Date:{' '}
          {policyData?.effectiveAt
            ? new Date(policyData.effectiveAt).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
              })
            : 'October 21, 2019'}
        </p>
        <hr className="border-gray-600 mb-6" />
        <div className="bg-gray-900 text-white rounded-lg p-4 mx-6">
          {loading ? (
            <p className="text-center text-lg text-gray-400">Loading...</p>
          ) : policyData?.body ? (
            <div
              className="text-gray-300 leading-relaxed space-y-6 [&>p]:mb-3 [&>ul]:list-disc [&>ul]:ml-6 [&>ol]:list-decimal [&>ol]:ml-6 [&>h3]:text-2xl [&>h3]:font-semibold [&>h3]:text-gray-200 [&>h3]:mb-3"
              dangerouslySetInnerHTML={{ __html: policyData.body }}
            />
          ) : (
            <p className="text-center text-lg text-gray-400">
              No privacy policy available.
            </p>
          )}
        </div>
      </div>
    </>
  );
}

export default PrivacyPolicy;
